'use strict';

module.exports = hardBreak;

var u = require('unist-builder');

/* Transform an inline break. */
function hardBreak(h, node) {
  return [h(node, 'br'), u('text', '\n')];
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/handlers/break.js
// module id = 216
// module chunks = 96961042003272 139266963665775